export const PAGE = {
  LOGIN: "/",
  IDLESTATE: "/idle",
  IDLESTATEMOBILE: "/mobileIdle",
  HOME: "/home",
  ADMIN: "/admin",
  GLOBAL_STATE_ADMIN: "/admin/global/:state",
  STATE_ADMIN: "/stateAdmin",
  NEW_PATIENT: "/patient/new",
  VIEW_PATIENT: "/patient/view/:id",
  EDIT_PATIENT: "/patient/edit/:id",
  VIEW_PATIENT_DETAILS: "/patient/details/:id",
  ADD_USERS: "/addUsers/:userId",
  SCREENING_IFRAME: "/screening",
  VIEW_USERS: "/viewUsers/:userType/:userName",
  EDIT_ASHA: "/editUser/:userType/:userName",
  UPDATE_ASHA:"/updateAsha/",
  GLOBAL_HOME: "/globalHome",
  USER_PROFILE: "/profile/:role",
  HEALTH_CHECK: "/healthcheck",
  HEALTH_CHECK_JSON: "/healthcheck/:id",
  INTROSPECT: "/introspect",
  NETWORK_ERROR: "/network/error",
};
